import React, { PureComponent } from 'react';

export class RedLightBulb extends PureComponent {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="97" height="97" viewBox="0 0 97 97">
                <circle cx="48.5" cy="48.5" r="48.5" fill="#e21837" />
                <g fill="#fff">
                    <path d="M59.9,56.6c0.3-0.3,0.6-0.7,0.9-1.1c0,0,0,0,0,0c0.3-0.4,0.6-0.8,0.9-1.2c0.1-0.1,0.1-0.2,0.2-0.3 c0.5-0.8,0.9-1.7,1.2-2.5l0.2-0.4c0.1-0.2,0.2-0.5,0.2-0.7c0.1-0.4,0.2-0.8,0.3-1.1c0-0.1,0-0.2,0.1-0.3l0-0.1 c0.1-0.3,0.1-0.6,0.1-1l0.1-0.4c0-0.5,0.1-0.9,0.1-1.4c0-8.6-7-15.6-15.6-15.6s-15.6,7-15.6,15.6c0,0.5,0,0.9,0.1,1.4l0,0.4 c0,0.3,0.1,0.6,0.1,1l0.1,0.5c0.1,0.4,0.2,0.8,0.3,1.1c0.1,0.2,0.1,0.4,0.2,0.6c0,0,0,0.1,0,0.1l0.2,0.4c0.4,0.9,0.8,1.8,1.3,2.7 c0,0,0,0.1,0.1,0.1c0.3,0.5,0.6,0.9,0.9,1.3c0,0,0,0,0,0c0.3,0.4,0.6,0.7,0.9,1.1c2.2,3.1,3.3,6,3.3,8.3c0,0.1,0,0.2,0.1,0.3 c0,0.1-0.1,0.2-0.1,0.3v9c0,0.2,0.1,0.4,0.2,0.6c0.5,3.9,3.8,7,7.9,7c4.2,0,7.7-3.3,7.9-7.5c0,0,0-0.1,0-0.1V65c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0C56.6,62.6,57.8,59.7,59.9,56.6z M39.5,55c0-0.1-0.1-0.1-0.2-0.2c-0.3-0.3-0.6-0.6-0.9-1 c0,0,0,0,0,0c-0.2-0.3-0.5-0.7-0.7-1.1c0,0,0,0,0,0c0,0,0,0,0,0c-0.4-0.7-0.8-1.5-1.1-2.2L36.5,50c-0.1-0.2-0.1-0.3-0.2-0.5 c-0.1-0.3-0.2-0.6-0.2-0.9L36,48.2c0-0.3-0.1-0.5-0.1-0.9l0-0.3c0-0.4-0.1-0.8-0.1-1.2c0-7.1,5.8-12.9,12.9-12.9 s12.9,5.8,12.9,12.9c0,0.4,0,0.8-0.1,1.2l0,0.4c0,0.3-0.1,0.5-0.1,0.8l-0.1,0.4c-0.1,0.3-0.2,0.6-0.2,1c-0.1,0.2-0.1,0.4-0.2,0.6 l-0.1,0.3c-0.3,0.8-0.7,1.5-1.1,2.2c0,0,0,0.1-0.1,0.1c-0.2,0.3-0.5,0.7-0.7,1c0,0,0,0,0,0.1c-0.3,0.3-0.6,0.7-0.8,1 c-0.1,0.1-0.1,0.1-0.2,0.2c-1.6,2.2-3.4,5.4-3.7,8.6H43.4c0,0-0.1,0-0.1,0C42.9,60.4,41.1,57.2,39.5,55z M54,66.3v2.3H43.4 c0,0,0,0,0,0v-2.4c0,0,0,0,0,0L54,66.3L54,66.3z M43.4,73.1v-1.9c0,0,0,0,0,0H54v1.8L43.4,73.1L43.4,73.1z M48.7,79.4 c-2.3,0-4.3-1.5-5-3.6h9.9C53,77.8,51,79.4,48.7,79.4z" />
                    <path d="M18.6,47.6c0,0.7,0.6,1.3,1.3,1.3h7.2c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3h-7.2 C19.2,46.2,18.6,46.8,18.6,47.6z" />
                    <path d="M19.6,32.9c-0.2,0.7,0.1,1.4,0.8,1.7l6.7,2.4c0.1,0.1,0.3,0.1,0.4,0.1c0.5,0,1.1-0.3,1.2-0.9 c0.2-0.7-0.1-1.4-0.8-1.7l-6.7-2.4C20.6,31.9,19.8,32.2,19.6,32.9z" />
                    <path d="M33.5,29.5c0.3,0,0.7-0.1,0.9-0.4c0.5-0.5,0.5-1.4,0-1.9l-5.1-5c-0.5-0.5-1.4-0.5-1.9,0 c-0.5,0.5-0.5,1.4,0,1.9l5.1,5C32.8,29.4,33.1,29.5,33.5,29.5z" />
                    <path d="M77.3,47.6c0-0.7-0.6-1.3-1.3-1.3h-7.2c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3h7.2 C76.7,48.9,77.3,48.3,77.3,47.6z" />
                    <path d="M64.9,61l6.1,3.7c0.2,0.1,0.5,0.2,0.7,0.2c0.4,0,0.9-0.2,1.1-0.6c0.4-0.6,0.2-1.4-0.4-1.8 l-6.1-3.7c-0.6-0.4-1.4-0.2-1.8,0.4C64.1,59.8,64.2,60.6,64.9,61z" />
                    <path d="M29.8,58.7l-6.1,3.7c-0.6,0.4-0.8,1.2-0.4,1.8c0.2,0.4,0.7,0.6,1.1,0.6c0.2,0,0.5-0.1,0.7-0.2 l6.1-3.7c0.6-0.4,0.8-1.2,0.4-1.8C31.3,58.5,30.5,58.3,29.8,58.7z" />
                    <path d="M74.6,32.1l-6.7,2.4c-0.7,0.2-1,1-0.8,1.7c0.2,0.5,0.7,0.9,1.2,0.9c0.1,0,0.3,0,0.4-0.1l6.7-2.4 c0.7-0.2,1-1,0.8-1.7C76.1,32.2,75.3,31.9,74.6,32.1z" />
                    <path d="M67.9,22.2c-0.5-0.5-1.4-0.5-1.9,0l-5.1,5c-0.5,0.5-0.5,1.4,0,1.9c0.3,0.3,0.6,0.4,0.9,0.4 c0.3,0,0.7-0.1,0.9-0.4l5.1-5C68.4,23.6,68.4,22.8,67.9,22.2z" />
                    <path d="M46.3,17.1V25c0,0.7,0.6,1.3,1.3,1.3S49,25.7,49,25v-7.8c0-0.7-0.6-1.3-1.3-1.3 S46.3,16.4,46.3,17.1z" />
                </g>
            </svg>
        );
    }
}

class Icon extends PureComponent {
    render() {
        return (
            <svg
                className="hazard-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="155"
                height="155"
                viewBox="0 0 155 155"
            >
                <circle cx="77.5" cy="77.5" r="76" className={this.props.class || 'icon-circle'} />
                {this.props.children}
            </svg>
        );
    }
}

export class Chemical extends PureComponent {
    render() {
        return (
            <Icon>
                <g className="icon">
                    <path d="M113.1,116.3L88.5,62.9V33.1h3.2c0.8,0,1.5-0.7,1.5-1.5c0-0.8-0.7-1.5-1.5-1.5H63.3c-0.8,0-1.5,0.7-1.5,1.5 s0.7,1.5,1.5,1.5h3.2v29.8l-24.6,53.4c-1,2.2-1,4.4,0.1,6.1c1.1,1.7,3,2.6,5.5,2.6h60c2.5,0,4.4-0.9,5.5-2.6 C114.1,120.7,114.1,118.5,113.1,116.3z M110.4,120.7c-0.5,0.8-1.5,1.2-2.9,1.2h-60c-1.4,0-2.4-0.4-2.9-1.2 c-0.5-0.8-0.5-1.9,0.1-3.1l15.7-34.1h34.1l15.7,34.1C110.9,118.8,110.9,119.9,110.4,120.7z M61.9,80.4l7.6-16.5 c0.1-0.2,0.1-0.4,0.1-0.6V33.1h15.8v30.1c0,0.2,0,0.4,0.1,0.6l7.6,16.5H61.9z" />
                    <path d="M69.3,90.5c-3.4,0-6.2,2.8-6.2,6.2c0,3.4,2.8,6.2,6.2,6.2c3.4,0,6.2-2.8,6.2-6.2C75.5,93.2,72.7,90.5,69.3,90.5z M72.4,96.7c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1C71,93.5,72.4,94.9,72.4,96.7z" />
                    <path d="M83.3,102.8c-3.6,0-6.6,2.9-6.6,6.6s2.9,6.6,6.6,6.6s6.6-2.9,6.6-6.6S86.9,102.8,83.3,102.8z M83.3,112.9 c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5C86.8,111.3,85.2,112.9,83.3,112.9z" />
                    <path d="M86.4,86.5c-2.8,0-5.1,2.3-5.1,5.1c0,1.4,0.5,2.7,1.5,3.6s2.3,1.5,3.6,1.5c2.8,0,5.1-2.3,5.1-5.1 C91.6,88.8,89.3,86.5,86.4,86.5z M88.5,91.7c0,1.1-0.9,2-2.1,2c-1.1,0-2-0.9-2-2c0-1.1,0.9-2.1,2-2.1 C87.6,89.6,88.5,90.5,88.5,91.7z" />
                </g>
            </Icon>
        );
    }
}

export class Heights extends PureComponent {
    render() {
        return (
            <Icon>
                <g className="icon">
                    <path d="M82.5,118c0,1.4-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5v-11.4H49.6V118c0,1.4-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5V37 c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v11.4h27.8V37c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v81H82.5z M49.6,101.5h27.8V88.9H49.6 V101.5z M49.6,83.8h27.8V71.2H49.6V83.8z M49.6,53.5v12.6h27.8V53.5H49.6z M110.3,65.9v29.3c0,1.4-1.1,2.5-2.5,2.5 s-2.5-1.1-2.5-2.5V65.9l-5.8,5.8c-1,1-2.6,1-3.6,0s-1-2.6,0-3.6L106,58c1-1,2.6-1,3.6,0l10.1,10.1c1,1,1,2.6,0,3.6s-2.6,1-3.6,0 L110.3,65.9z" />
                </g>
            </Icon>
        );
    }
}

export class ColdWeather extends PureComponent {
    render() {
        return (
            <Icon>
                <g className="icon">
                    <path
                        d="M119,95.7l-0.1-0.1l-3.6-2.1l4.3-2.9c0.8-0.6,1.1-1.7,0.5-2.5c-0.6-0.8-1.7-1.1-2.5-0.5l-5.9,3.9l-2.8-1.6l4.4-2.9
			c0.8-0.6,1.1-1.7,0.5-2.5s-1.7-1.1-2.5-0.5l-5.9,3.9l-4.4-2.6V69.1l4.4-2.6l5.9,3.9c0.3,0.2,0.7,0.3,1,0.3c0.6,0,1.2-0.3,1.5-0.8
			c0.6-0.8,0.3-2-0.5-2.5l-4.3-2.9l2.8-1.6l5.9,3.9c0.3,0.2,0.7,0.3,1,0.3c0.6,0,1.2-0.3,1.5-0.8c0.6-0.8,0.3-2-0.5-2.5l-4.3-2.9
			l3.8-2.2c0.9-0.5,1.2-1.6,0.7-2.5c-0.5-0.9-1.6-1.2-2.5-0.7l-3.8,2.2l-0.3-5.2c-0.1-1-0.9-1.7-1.9-1.7c-1,0.1-1.8,0.9-1.7,1.9
			l0.4,7l-2.8,1.6l-0.3-5.2c-0.1-1-0.9-1.7-1.9-1.7c-1,0.1-1.8,0.9-1.7,1.9l0.4,7l-4.4,2.6l-14-8.1v-5.1l6.3-3.1
			c0.9-0.5,1.3-1.5,0.8-2.5c-0.5-0.9-1.6-1.3-2.5-0.8l-4.7,2.3v-3.2l6.3-3.1c0.9-0.5,1.3-1.5,0.8-2.5c-0.5-0.9-1.6-1.3-2.5-0.8
			l-4.7,2.3V37c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8v4.3L76.8,39c-0.9-0.4-2-0.1-2.5,0.8c-0.4,0.9-0.1,2,0.8,2.5l6.3,3.1v3.2
			l-4.7-2.3c-0.9-0.4-2-0.1-2.5,0.8c-0.4,0.9-0.1,2,0.8,2.5l6.3,3.1v5.1l-14.9,8.6c0,0,0,0,0,0c0,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0.1
			c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0.1c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1
			c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1
			c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0v0c0,0,0,0,0,0v18.2c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1
			c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0
			c0.2,0.3,0.4,0.5,0.7,0.7l14.9,8.6v5.1l-6.3,3.1c-0.9,0.5-1.3,1.5-0.8,2.5c0.5,0.9,1.5,1.3,2.5,0.8l4.7-2.3v3.2l-6.3,3.1
			c-0.9,0.5-1.3,1.5-0.8,2.5c0.5,0.9,1.5,1.3,2.5,0.8l4.7-2.3v4.3c0,1,0.8,1.8,1.8,1.8c0.1,0,0.1,0,0.2,0c0.9-0.1,1.6-0.9,1.6-1.8v0
			V113l4.7,2.3c0.3,0.1,0.5,0.2,0.8,0.2c0.7,0,1.3-0.4,1.6-1c0.4-0.9,0.1-2-0.8-2.5l-6.3-3.1v-3.2l4.7,2.3c0.3,0.1,0.5,0.2,0.8,0.2
			c0.7,0,1.3-0.4,1.6-1c0.4-0.9,0.1-2-0.8-2.5l-6.3-3.1v-5.1l14-8.1l4.4,2.6l-0.4,7c-0.1,1,0.7,1.9,1.7,1.9c0,0,0.1,0,0.1,0
			c1,0,1.8-0.7,1.8-1.7l0.3-5.2l2.8,1.6l-0.4,7c-0.1,1,0.7,1.9,1.7,1.9c0,0,0.1,0,0.1,0c1,0,1.8-0.7,1.8-1.7l0.3-5.2l3.8,2.2
			c0.3,0.2,0.6,0.2,0.9,0.2c0.6,0,1.2-0.3,1.6-0.9c0-0.1,0.1-0.1,0.1-0.2c0.1-0.2,0.2-0.5,0.2-0.7C119.9,96.7,119.6,96,119,95.7z
			 M83.3,61l14,8.1v16.1l-14,8.1l-14-8.1V69.1L83.3,61z"
                    />
                    <path
                        d="M76,75.1l3.6,2.1L76,79.2c-0.9,0.5-1.2,1.6-0.7,2.5c0.3,0.6,1,0.9,1.6,0.9c0.3,0,0.6-0.1,0.9-0.2l3.6-2.1v4.1
			c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8v-4.1l3.6,2.1c0.3,0.2,0.6,0.2,0.9,0.2c0.6,0,1.2-0.3,1.6-0.9c0.5-0.9,0.2-2-0.7-2.5
			l-3.6-2.1l3.6-2.1c0.9-0.5,1.2-1.6,0.7-2.5c-0.5-0.9-1.6-1.2-2.5-0.7L85.1,74v-4.1c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8V74
			l-3.6-2.1c-0.9-0.5-2-0.2-2.5,0.7C74.9,73.5,75.2,74.6,76,75.1z"
                    />
                    <path
                        d="M59.5,44.3c0-5-4.1-9.1-9.1-9.1s-9.1,4.1-9.1,9.1v56.8c-2.3,2.4-3.7,5.6-3.7,8.9c0,7,5.7,12.8,12.8,12.8
			s12.8-5.7,12.8-12.8c0-3.3-1.3-6.5-3.7-8.9V44.3z M50.4,119.2c-5,0-9.1-4.1-9.1-9.1c0-2.6,1.1-5,3-6.8c0.4-0.4,0.6-0.8,0.6-1.4
			V44.3c0-3,2.5-5.5,5.5-5.5c3,0,5.5,2.5,5.5,5.5v57.6c0,0.5,0.2,1,0.6,1.4c2,1.8,3,4.2,3,6.8C59.5,115.1,55.4,119.2,50.4,119.2z"
                    />
                    <path
                        d="M52.2,104.9v-35c0-1-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8v35c-2.1,0.8-3.7,2.8-3.7,5.2c0,3,2.5,5.5,5.5,5.5
			c3,0,5.5-2.5,5.5-5.5C55.9,107.7,54.4,105.6,52.2,104.9z M50.4,111.9c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8
			S51.4,111.9,50.4,111.9z"
                    />
                </g>
            </Icon>
        );
    }
}

export class Construction extends PureComponent {
    render() {
        return (
            <Icon>
                <g className="icon">
                    <path
                        d="M131.3,119h-26.1c-1.4,0-2.3-0.9-2.3-2.3V97.9c0-1.4,0.9-2.3,2.3-2.3h26.1c1.4,0,2.3,0.9,2.3,2.3v18.9
				C133.5,118.1,132.6,119,131.3,119z M107.4,114.5H129v-14.3h-21.6V114.5z"
                    />
                    <path
                        d="M105.1,119H79c-1.4,0-2.3-0.9-2.3-2.3V97.9c0-1.4,0.9-2.3,2.3-2.3h26.1c1.4,0,2.3,0.9,2.3,2.3v18.9
				C107.4,118.1,106.5,119,105.1,119z M81.3,114.5h21.6v-14.3H81.3V114.5z"
                    />
                    <path
                        d="M79,119H52.9c-1.4,0-2.3-0.9-2.3-2.3V97.9c0-1.4,0.9-2.3,2.3-2.3H79c1.4,0,2.3,0.9,2.3,2.3v18.9
				C81.3,118.1,80.4,119,79,119z M55.1,114.5h21.6v-14.3H55.1V114.5z"
                    />
                    <path
                        d="M118.3,100.1H92.2c-1.4,0-2.3-0.9-2.3-2.3V79c0-1.4,0.9-2.3,2.3-2.3h26.1c1.4,0,2.3,0.9,2.3,2.3v18.9
				C120.6,99.2,119.7,100.1,118.3,100.1z M94.5,95.6H116V81.3H94.5V95.6z"
                    />
                    <path
                        d="M92.2,100.1H66c-1.4,0-2.3-0.9-2.3-2.3V79c0-1.4,0.9-2.3,2.3-2.3h26.1c1.4,0,2.3,0.9,2.3,2.3v18.9
				C94.5,99.2,93.5,100.1,92.2,100.1z M68.3,95.6h21.6V81.3H68.3V95.6z"
                    />
                    <path
                        d="M105.1,81.3H79c-1.4,0-2.3-0.9-2.3-2.3V60.1c0-1.4,0.9-2.3,2.3-2.3h26.1c1.4,0,2.3,0.9,2.3,2.3V79
				C107.4,80.4,106.5,81.3,105.1,81.3z M81.3,76.7h21.6V62.4H81.3V76.7z"
                    />
                    <path
                        d="M92.2,62.4H66c-1.4,0-2.3-0.9-2.3-2.3V41.3c0-1.4,0.9-2.3,2.3-2.3h26.1c1.4,0,2.3,0.9,2.3,2.3v18.9
				C94.5,61.5,93.5,62.4,92.2,62.4z M68.3,57.9h21.6V43.5H68.3V57.9z"
                    />
                    <path
                        d="M79,81.3H52.9c-1.4,0-2.3-0.9-2.3-2.3V60.1c0-1.4,0.9-2.3,2.3-2.3H79c1.4,0,2.3,0.9,2.3,2.3V79
				C81.3,80.4,80.4,81.3,79,81.3z M55.1,76.7h21.6V62.4H55.1V76.7z"
                    />
                    <path
                        d="M66,100.1H39.9c-1.4,0-2.3-0.9-2.3-2.3V79c0-1.4,0.9-2.3,2.3-2.3H66c1.4,0,2.3,0.9,2.3,2.3v18.9
				C68.3,99.2,67.4,100.1,66,100.1z M42.2,95.6h21.6V81.3H42.2V95.6z"
                    />
                    <path
                        d="M52.9,119H26.7c-1.4,0-2.3-0.9-2.3-2.3V97.9c0-1.4,0.9-2.3,2.3-2.3h26.1c1.4,0,2.3,0.9,2.3,2.3v18.9
				C55.1,118.1,54.2,119,52.9,119z M29,114.5h21.6v-14.3H29V114.5z"
                    />
                </g>
            </Icon>
        );
    }
}

export class Cuts extends PureComponent {
    render() {
        return (
            <Icon>
                <g className="icon">
                    <path
                        d="M83.7,60.1c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0c0.3,0.3,0.4,0.6,0.4,1
				c0,0.4-0.2,0.7-0.4,1C84.4,60,84,60.1,83.7,60.1z"
                    />
                    <path
                        d="M99.3,75.7c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0c0.3,0.3,0.4,0.6,0.4,1
				c0,0.4-0.2,0.7-0.4,1C100,75.6,99.6,75.7,99.3,75.7z"
                    />
                    <path
                        d="M91.5,67.9c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0c0.3,0.3,0.4,0.6,0.4,1
				c0,0.4-0.2,0.7-0.4,1C92.2,67.8,91.8,67.9,91.5,67.9L91.5,67.9z"
                    />
                    <path
                        d="M92.2,59.4c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0c0.3,0.3,0.4,0.6,0.4,1
				s-0.1,0.7-0.4,1C93,59.2,92.6,59.4,92.2,59.4z"
                    />
                    <path
                        d="M100,67.2c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0c0.3,0.3,0.4,0.6,0.4,1
				c0,0.4-0.2,0.7-0.4,1C100.8,67,100.4,67.2,100,67.2z"
                    />
                    <path
                        d="M101.6,50c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0c0.3,0.3,0.4,0.6,0.4,1
				c0,0.4-0.2,0.7-0.4,1C102.3,49.9,102,50,101.6,50z"
                    />
                    <path
                        d="M109.4,57.8c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0
				c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.2,0.7-0.4,1C110.1,57.7,109.8,57.8,109.4,57.8L109.4,57.8z"
                    />
                    <path
                        d="M93,50.8c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0c0.3,0.3,0.4,0.6,0.4,1
				c0,0.4-0.2,0.7-0.4,1C93.8,50.6,93.4,50.8,93,50.8z"
                    />
                    <path
                        d="M108.6,66.4c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0
				c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.2,0.7-0.4,1C109.3,66.2,109,66.4,108.6,66.4L108.6,66.4z"
                    />
                    <path
                        d="M100.8,58.6c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0
				c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.2,0.7-0.4,1C101.5,58.4,101.2,58.6,100.8,58.6z"
                    />
                    <path
                        d="M58.7,85.1c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1s0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0c0.3,0.3,0.4,0.6,0.4,1
				s-0.2,0.7-0.4,1C59.5,84.9,59.1,85.1,58.7,85.1z"
                    />
                    <path
                        d="M74.3,100.7c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0
				c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.2,0.7-0.4,1C75.1,100.5,74.7,100.7,74.3,100.7z"
                    />
                    <path
                        d="M66.5,92.9c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0c0.3,0.3,0.4,0.6,0.4,1
				c0,0.4-0.2,0.7-0.4,1C67.3,92.7,66.9,92.9,66.5,92.9L66.5,92.9z"
                    />
                    <path
                        d="M58,93.6c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0c0.3,0.3,0.4,0.6,0.4,1
				c0,0.4-0.2,0.7-0.4,1C58.7,93.5,58.3,93.6,58,93.6z"
                    />
                    <path
                        d="M65.7,101.4c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0
				c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.2,0.7-0.4,1C66.5,101.3,66.1,101.4,65.7,101.4L65.7,101.4z"
                    />
                    <path
                        d="M48.6,103c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0c0.3,0.3,0.4,0.6,0.4,1
				c0,0.4-0.2,0.7-0.4,1C49.3,102.9,49,103,48.6,103z"
                    />
                    <path
                        d="M56.4,110.8c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0
				c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.2,0.7-0.4,1C57.1,110.7,56.8,110.8,56.4,110.8L56.4,110.8z"
                    />
                    <path
                        d="M49.4,94.4c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0c0.3,0.3,0.4,0.6,0.4,1
				c0,0.4-0.2,0.7-0.4,1C50.1,94.3,49.8,94.4,49.4,94.4z"
                    />
                    <path
                        d="M65,110c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0c0.3,0.3,0.4,0.6,0.4,1
				c0,0.4-0.2,0.7-0.4,1C65.7,109.9,65.3,110,65,110L65,110z"
                    />
                    <path
                        d="M57.2,102.2c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.5-0.5,1.5-0.5,2,0
				c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.2,0.7-0.4,1C57.9,102.1,57.5,102.2,57.2,102.2z"
                    />
                    <path
                        d="M55.7,122.2c-5.3,0-10.3-2.1-14-5.8c-7.7-7.7-7.7-20.3,0-28.1c0,0,46.3-46.3,46.6-46.6c3.8-3.8,8.7-5.8,14-5.8
				c5.3,0,10.3,2.1,14,5.8c7.7,7.7,7.7,20.3,0,28.1c-0.3,0.3-46.6,46.6-46.6,46.6C66,120.1,61,122.2,55.7,122.2L55.7,122.2z
				 M102.3,38.6c-4.6,0-8.8,1.8-12.1,5C89.9,44,43.6,90.2,43.6,90.2c-6.6,6.6-6.6,17.5,0,24.1c3.2,3.2,7.5,5,12.1,5
				c4.6,0,8.8-1.8,12.1-5l46.6-46.6c6.6-6.6,6.6-17.5,0-24.1C111.1,40.4,106.9,38.6,102.3,38.6L102.3,38.6z"
                    />
                    <path
                        d="M79,94.6c-0.4,0-0.7-0.1-1-0.4L63.8,80c-0.5-0.5-0.5-1.4,0-2L78,63.8c0.5-0.5,1.5-0.5,2,0L94.2,78c0.3,0.3,0.4,0.6,0.4,1
				s-0.1,0.7-0.4,1L80,94.2C79.7,94.4,79.4,94.6,79,94.6L79,94.6z M66.8,79L79,91.2L91.2,79L79,66.8L66.8,79z"
                    />
                </g>
            </Icon>
        );
    }
}

export class Electrical extends PureComponent {
    render() {
        return (
            <Icon>
                <g className="icon">
                    <path
                        d="M100.6,58.5h-4.1V42.6c0-3-2.4-5.4-5.4-5.4s-5.4,2.4-5.4,5.4v15.9H72.2V42.6c0-3-2.4-5.4-5.4-5.4s-5.4,2.4-5.4,5.4v15.9h-4
            c-3.8,0-6.8,3.1-6.8,6.8c0,2.1,1,4.1,2.7,5.4v23c0,0.4,0.2,0.8,0.4,1l9.5,9.5c0.3,0.3,0.6,0.4,1,0.4h5.3v6.7c0,0.8,0.7,1.4,1.4,1.4
            h4v6.7c0,0.8,0.7,1.4,1.4,1.4h5.4c0.7,0,1.4-0.6,1.4-1.4v-6.7h4c0.7,0,1.4-0.6,1.4-1.4v-6.7h5.3c0.4,0,0.7-0.1,1-0.4l9.5-9.5
            c0.3-0.3,0.4-0.6,0.4-1v-23c1.7-1.3,2.7-3.3,2.7-5.4C107.4,61.5,104.3,58.5,100.6,58.5z M88.5,42.6c0-1.5,1.2-2.7,2.7-2.7
            s2.7,1.2,2.7,2.7v15.9h-5.4C88.5,57.9,88.5,42.6,88.5,42.6z M64.2,42.6c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7v15.9h-5.4
            C64.2,57.9,64.2,42.6,64.2,42.6z M80.3,118.1h-2.7v-5.4h2.7V118.1z M85.7,110h-3.5c-0.2-0.1-0.3-0.1-0.5-0.1h-5.4
            c-0.2,0-0.3,0-0.5,0.1h-3.6v-5.4h13.5V110z M102.7,69c-0.4,0.3-0.7,0.7-0.7,1.2v23l-8.7,8.7h-5.7c-0.2-0.1-0.3-0.1-0.5-0.1H70.9
            c-0.2,0-0.3,0-0.5,0.1h-5.7L56,93.3V70.2c0-0.5-0.3-1-0.7-1.2c-1.2-0.7-2-2.1-2-3.5c0-2.3,1.9-4.1,4.1-4.1h4.9
            c0.2,0.1,0.3,0.1,0.5,0.1h8.1c0.2,0,0.4,0,0.5-0.1h15.2c0.2,0.1,0.3,0.1,0.5,0.1h8.1c0.2,0,0.3,0,0.5-0.1h4.9c2.3,0,4.1,1.9,4.1,4.1
            C104.7,67,104,68.3,102.7,69z M92.6,89.7c-0.1,0.8-0.7,1.4-1.5,1.4H66.9c-0.7,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4h24.3
            C91.9,88.3,92.6,88.9,92.6,89.7z M95.3,81.7c-0.1,0.7-0.7,1.4-1.5,1.4H64.2c-0.7,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4h29.7
            C94.6,80.3,95.3,80.9,95.3,81.7z M65.5,73.5c0-0.8,0.6-1.4,1.4-1.4h24.3c0.7,0,1.4,0.6,1.4,1.4c-0.1,0.9-0.7,1.4-1.5,1.4H66.9
            C66.2,74.9,65.5,74.3,65.5,73.5z"
                    />
                </g>
            </Icon>
        );
    }
}

export class Explosives extends PureComponent {
    render() {
        return (
            <Icon>
                <g className="icon">
                    <path
                        d="M105.9,31.7v3.8c0,0.4-0.2,0.8-0.5,1L95.9,44c4.2,0.2,8.5-0.1,12.3-0.9c1-0.1,1.4,0.6,1.5,1.3v8.9c0,0.9-1.2,1.5-1.9,1
			c-1.5-1-4.6-1.7-8-2c-3-0.3-6.2-0.3-9.1-0.3c0.1,2.2,0,3.2,0,5.3c2.7,0.3,5,1.5,6.5,3.4c1.7,2.2,2.5,5,2.5,7.8v55.8
			c0,0.7-0.6,1.3-1.3,1.3h-33c-0.7,0-1.3-0.6-1.3-1.3V68.5c0-2.8,0.8-5.6,2.5-7.8c1.5-1.9,3.7-3,6.5-3.4c0-2.3,0-3.7,0-5.3h-5.2
			c-0.7,0-1.3-0.6-1.3-1.3v-3.6c-7.4,0.8-13.1,3-16.8,7.2C45.8,59,44,66.2,45,77.5c3.5,1.5,5,5.3,5.9,8.3c1.5,4.9,2.4,11.6,3,19.3
			c0.1,0.7-0.6,1.4-1.3,1.4H37.5c-0.7,0-1.3-0.8-1.2-1.5c0.6-4.3,0.9-11,1.7-16.6c0.7-3.9,1.2-8.6,4.5-10.8
			C41.4,66,43.4,58,47.9,52.8c4.3-5,10.8-7.3,18.7-8.2v-4c0-0.7,0.6-1.3,1.3-1.3h12.7c1.6,0,3.2,0.3,4.6,0.8l19-9.5
			C105.3,30.3,105.8,30.8,105.9,31.7L105.9,31.7z M103.4,33.8l-16,8c0.4,0.4,0.7,0.9,1,1.4c1.2,0.2,2.5,0.4,3.7,0.6l11.2-8.8
			L103.4,33.8z M81.9,41.9c-2.8,0-5.1,2.3-5.1,5.1s2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1C86.9,44.1,84.7,41.9,81.9,41.9z
			 M107.2,45.8c-5.7,1-12.1,1-17.8,0.1c0.2,1.2-0.1,2.5-0.4,3.6c3.8,0,7.7,0,11,0.3c2.7,0.2,5.1,0.8,7.2,1.6L107.2,45.8z M92,76.1
			H71.7v22.8H92V76.1z M84.4,81.2v2.5h-5.1v-2.5H84.4z M86.9,86.2v2.5H76.8v-2.5H86.9z M86.9,91.3v2.5h-7.6v-2.5H86.9z"
                    />
                </g>
            </Icon>
        );
    }
}

export class HighSecurity extends PureComponent {
    render() {
        return (
            <Icon>
                <g className="icon">
                    <path
                        d="M112.3,70.6l-4.2-0.7c-0.5-1.7-1.2-3.3-2-4.9l2.4-3.5l0,0c1.7-2.5,1.4-5.8-0.7-8l-3.2-3.2c-2.1-2.1-5.5-2.4-8-0.7L93.1,52
            l0,0c-1.6-0.8-3.2-1.5-4.9-2l-0.7-4.2c-0.5-3-3.1-5.2-6.2-5.2h-4.6c-3,0-5.6,2.2-6.1,5.1l-0.7,4.2c-1.7,0.5-3.3,1.2-4.9,2l-3.5-2.4
            l0,0c-2.5-1.7-5.8-1.4-8,0.7l-3.2,3.2c-2.1,2.1-2.4,5.5-0.7,8l2.4,3.5l0,0c-0.8,1.6-1.5,3.2-2,4.9l-4.2,0.7c-3,0.5-5.2,3.1-5.2,6.2
            v4.6c0,3,2.2,5.6,5.1,6.1l4.2,0.7c0.5,1.7,1.2,3.3,2,4.9l-2.4,3.5l0,0c-1.7,2.5-1.4,5.8,0.7,8l3.2,3.2c2.1,2.1,5.5,2.4,8,0.7L65,106
            l0,0c1.6,0.8,3.2,1.5,4.9,2l0.7,4.2c0.5,3,3.1,5.2,6.1,5.1h4.6c3,0,5.6-2.2,6.1-5.1l0.7-4.2c1.7-0.5,3.3-1.2,4.9-2l3.5,2.4
            c2.5,1.7,5.8,1.4,8-0.7l3.2-3.2c2.1-2.1,2.4-5.5,0.7-8L106,93l0,0c0.8-1.6,1.5-3.2,2-4.9l4.2-0.7l0,0c3-0.5,5.2-3.1,5.2-6.1v-4.6
            C117.4,73.7,115.3,71.1,112.3,70.6L112.3,70.6z M113.4,81.3c0,1.1-0.8,2-1.8,2.1l-5.5,1l0,0c-0.8,0.1-1.4,0.7-1.6,1.5
            c-0.6,2.2-1.5,4.3-2.6,6.3c-0.4,0.7-0.4,1.5,0.1,2.2l3.2,4.5c0.6,0.9,0.5,2-0.2,2.8l-3.2,3.2c-0.7,0.7-1.9,0.9-2.8,0.2l-4.6-3.2
            c-0.6-0.5-1.5-0.5-2.2-0.1c-2,1.1-4.1,2-6.3,2.6c-0.8,0.2-1.3,0.8-1.5,1.6l-1,5.4c-0.2,1-1.1,1.8-2.1,1.8h-4.6c-1.1,0-2-0.8-2.1-1.8
            l-1-5.5l0,0c-0.1-0.8-0.7-1.4-1.5-1.6c-2.2-0.6-4.3-1.5-6.3-2.6c-0.7-0.4-1.5-0.4-2.2,0.1l-4.5,3.2l0,0c-0.9,0.6-2,0.5-2.8-0.2
            l-3.2-3.2c-0.7-0.7-0.9-1.9-0.2-2.8l3.2-4.5c0.5-0.6,0.5-1.5,0.1-2.2c-1.1-2-2-4.1-2.6-6.3c-0.2-0.8-0.8-1.3-1.6-1.5l-5.4-1
            c-1-0.2-1.8-1.1-1.8-2.1v-4.6c0-1.1,0.8-2,1.8-2.1l5.5-1l0,0c0.8-0.1,1.4-0.7,1.6-1.5c0.6-2.2,1.5-4.3,2.6-6.3
            c0.4-0.7,0.4-1.5-0.1-2.2L53,59c-0.6-0.9-0.5-2,0.2-2.8l3.2-3.2c0.7-0.7,1.9-0.9,2.8-0.2l4.6,3.2c0.6,0.5,1.5,0.5,2.2,0.1
            c2-1.1,4.1-2,6.3-2.6c0.8-0.2,1.3-0.8,1.5-1.6l1-5.4c0.2-1,1.1-1.8,2.1-1.8h4.6c1.1,0,2,0.8,2.1,1.8l1,5.5l0,0
            c0.1,0.8,0.7,1.4,1.5,1.6c2.2,0.6,4.3,1.5,6.3,2.6c0.7,0.4,1.5,0.4,2.2-0.1l4.5-3.2c0.9-0.6,2-0.5,2.8,0.2l3.2,3.2
            c0.7,0.7,0.9,1.9,0.2,2.8l-3.2,4.6c-0.5,0.6-0.5,1.5-0.1,2.2c1.1,2,2,4.1,2.6,6.3c0.2,0.8,0.8,1.3,1.6,1.5l5.5,1l0,0
            c1,0.2,1.8,1.1,1.8,2.1L113.4,81.3z M84.8,79c1.4-1.6,2-3.8,1.6-5.9c-0.6-3.8-4.1-6.6-7.9-6.3c-3.9,0.3-6.9,3.5-6.9,7.4
            c0,1.8,0.6,3.5,1.8,4.8l-2.5,7c-0.6,1.7,0.2,3.5,1.9,4.1c4,1.6,8.5,1.6,12.6,0c1.7-0.6,2.5-2.5,1.9-4.1L84.8,79z M74.9,86.6l2.6-7.4
            c0.3-0.8,0-1.7-0.6-2.3c-1.1-0.9-1.6-2.4-1.1-3.8s1.8-2.3,3.2-2.3s2.7,0.9,3.2,2.3s0,2.9-1.1,3.8c-0.7,0.5-0.9,1.4-0.6,2.3l2.6,7.4
            C80.5,87.4,77.6,87.4,74.9,86.6L74.9,86.6z"
                    />
                </g>
            </Icon>
        );
    }
}

export class Office extends PureComponent {
    render() {
        return (
            <Icon>
                <g className="icon">
                    <path
                        d="M88.3,83.8c0-0.2,0-0.3,0-0.5L107,62.9c4-1.3,6.8-5.1,6.8-9.5c0-5.5-4.4-9.9-9.8-10l-30.9-6.5c-1.6-1.1-3.6-1.8-5.7-1.8
				c-5.2,0-9.5,4-9.9,9.2L46.7,48v10.9h5.5v-2.3H49v-7l8.5-3c0.7,4.8,4.9,8.4,9.8,8.4c1.1,0,2.2-0.2,3.2-0.5l16.5,3.8L76,67.2
				c-1.6-0.5-3.4-0.8-5.2-0.8c-9.7,0-17.5,7.9-17.5,17.5v24.7h-9.2v14.2h68.7v-14.2h-17L88.3,83.8z M111.6,53.4
				c0,4.3-3.5,7.7-7.7,7.7c-4.3,0-7.7-3.5-7.7-7.7c0-4.3,3.5-7.7,7.7-7.7C108.1,45.7,111.6,49.1,111.6,53.4z M67.4,52.8
				c-4.3,0-7.7-3.5-7.7-7.7c0-4.3,3.5-7.7,7.7-7.7c4.3,0,7.7,3.5,7.7,7.7C75.1,49.4,71.6,52.8,67.4,52.8z M73.6,52.9
				c2.3-1.8,3.8-4.6,3.8-7.8c0-1.9-0.6-3.8-1.5-5.3L99,44.7c-2.9,1.6-4.9,4.6-5.1,8.1l-4.6,3.7L73.6,52.9z M94.2,55.6
				c1,4.3,4.8,7.6,9.3,7.8L88,80.3c-1.1-5.3-4.7-9.8-9.5-12.1L94.2,55.6z M70.8,68.7c8.4,0,15.2,6.8,15.2,15.2s-6.8,15.2-15.2,15.2
				c-8.4,0-15.2-6.8-15.2-15.2C55.6,75.6,62.4,68.7,70.8,68.7z M55.6,92.5c3,5.3,8.7,8.9,15.2,8.9c7.9,0,14.5-5.2,16.7-12.4
				l5.9,19.6H55.6V92.5z M110.6,120.6H46.4v-9.7h64.2L110.6,120.6L110.6,120.6z"
                    />
                    <path
                        d="M70.8,91.9c4.4,0,8-3.6,8-8s-3.6-8-8-8c-4.4,0-8,3.6-8,8C62.9,88.3,66.5,91.9,70.8,91.9z M70.8,78.3
				c3.1,0,5.7,2.6,5.7,5.7c0,3.1-2.6,5.7-5.7,5.7c-3.1,0-5.7-2.6-5.7-5.7C65.2,80.8,67.7,78.3,70.8,78.3z"
                    />
                    <path
                        d="M103.9,58.2c2.7,0,4.8-2.2,4.8-4.8c0-2.7-2.2-4.8-4.8-4.8s-4.8,2.2-4.8,4.8C99.1,56.1,101.2,58.2,103.9,58.2z
				 M103.9,50.8c1.4,0,2.6,1.1,2.6,2.6c0,1.4-1.1,2.6-2.6,2.6c-1.4,0-2.6-1.1-2.6-2.6C101.3,52,102.5,50.8,103.9,50.8z"
                    />
                    <path
                        d="M67.4,40.3c-2.7,0-4.8,2.2-4.8,4.8c0,2.7,2.2,4.8,4.8,4.8s4.8-2.2,4.8-4.8C72.2,42.5,70,40.3,67.4,40.3z M67.4,47.7
				c-1.4,0-2.6-1.1-2.6-2.6c0-1.4,1.1-2.6,2.6-2.6c1.4,0,2.6,1.1,2.6,2.6C69.9,46.5,68.8,47.7,67.4,47.7z"
                    />
                </g>
            </Icon>
        );
    }
}

export class Outdoor extends PureComponent {
    render() {
        return (
            <Icon>
                <g className="icon">
                    <path
                        d="M118.1,69.8c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.5l-4.5-4.5l0,0c-0.1-0.1-0.2-0.2-0.3-0.2
			c-0.1,0-0.2-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.1-0.3,0.2l0,0l-4.5,4.5c-0.4,0.4-0.4,1,0,1.5c0.4,0.4,1,0.4,1.5,0
			l2.7-2.7v1.8l-4.2,4.2c-0.4,0.4-0.4,1,0,1.5c0.4,0.4,1,0.4,1.5,0l2.7-2.6v1.8l-4.2,4.2c-0.4,0.4-0.4,1,0,1.5c0.4,0.4,1,0.4,1.5,0
			l2.7-2.7v8h-3.6L84.6,37.7c-0.3-0.7-1.5-0.7-1.9,0l-15.9,30l-7.5-14c-0.3-0.7-1.5-0.7-1.9,0l-16.5,31h-1.7c-0.6,0-1,0.4-1,1
			s0.4,1,1,1h79.6c0.6,0,1-0.4,1-1s-0.4-1-1-1h-3.5v-8l2.7,2.7c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.5
			l-4.2-4.2v-1.9l2.7,2.7c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.5l-4.2-4.2v-1.8L118.1,69.8z M68.2,69.6
			l15.6-29.1l23.6,44.1H85.5v-8l2.7,2.7c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.5l-4.2-4.2v-1.9l2.7,2.7
			c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.5L85.5,69v-1.8l2.6,2.6c0.2,0.2,0.5,0.3,0.7,0.3
			c0.3,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.5l-4.5-4.5l0,0c-0.1-0.2-0.4-0.3-0.6-0.3s-0.5,0.1-0.7,0.3l0,0l-4.5,4.5
			c-0.4,0.4-0.4,1,0,1.5c0.4,0.4,1,0.4,1.5,0l2.7-2.7v1.8l-4.2,4.2c-0.4,0.4-0.4,1,0,1.5c0.4,0.4,1,0.4,1.5,0l2.7-2.7v1.8l-4.2,4.2
			c-0.4,0.4-0.4,1,0,1.5c0.4,0.4,1,0.4,1.5,0l2.7-2.7v8h-7.5l-8-14.6C68.1,69.8,68.2,69.7,68.2,69.6z M58.3,56.4l15.2,28.2H43.3
			L58.3,56.4z"
                    />
                    <path
                        d="M118.8,102.4c-0.6,0-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6
			s-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6c-2.5,0-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1s-1,0.4-1,1
			c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1
			s-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6c-2.5,0-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6
			c-2.5,0-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1c0,3.7,3,6.7,6.7,6.7c2.4,0,4.5-1.3,5.6-3.1c1.2,1.9,3.2,3.1,5.6,3.1
			c2.4,0,4.5-1.3,5.6-3.1c1.2,1.9,3.2,3.1,5.6,3.1c2.4,0,4.5-1.3,5.6-3.1c1.2,1.9,3.2,3.1,5.6,3.1s4.5-1.3,5.6-3.1
			c1.2,1.9,3.2,3.1,5.6,3.1c2.4,0,4.5-1.3,5.6-3.1c1.2,1.9,3.2,3.1,5.6,3.1s4.5-1.3,5.6-3.1c1.2,1.9,3.2,3.1,5.6,3.1
			c3.7,0,6.7-3,6.7-6.7C119.8,102.9,119.3,102.4,118.8,102.4z"
                    />
                    <path
                        d="M118.8,91.1c-0.6,0-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6
			s-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6c-2.5,0-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1s-1,0.4-1,1
			c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1
			s-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6c-2.5,0-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6
			c-2.5,0-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1c0,3.7,3,6.7,6.7,6.7c2.4,0,4.5-1.3,5.6-3.1c1.2,1.9,3.2,3.1,5.6,3.1
			c2.4,0,4.5-1.3,5.6-3.1c1.2,1.9,3.2,3.1,5.6,3.1c2.4,0,4.5-1.3,5.6-3.1c1.2,1.9,3.2,3.1,5.6,3.1s4.5-1.3,5.6-3.1
			c1.2,1.9,3.2,3.1,5.6,3.1c2.4,0,4.5-1.3,5.6-3.1c1.2,1.9,3.2,3.1,5.6,3.1s4.5-1.3,5.6-3.1c1.2,1.9,3.2,3.1,5.6,3.1
			c3.7,0,6.7-3,6.7-6.7C119.8,91.6,119.3,91.1,118.8,91.1z"
                    />
                    <path
                        d="M118.8,113.1c-0.6,0-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6
			s-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6c-2.5,0-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1s-1,0.4-1,1
			c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1
			s-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6c-2.5,0-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1c0,2.5-2.1,4.6-4.6,4.6
			c-2.5,0-4.6-2.1-4.6-4.6c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1c0,3.7,3,6.7,6.7,6.7c2.4,0,4.5-1.3,5.6-3.1c1.2,1.9,3.2,3.1,5.6,3.1
			c2.4,0,4.5-1.3,5.6-3.1c1.2,1.9,3.2,3.1,5.6,3.1c2.4,0,4.5-1.3,5.6-3.1c1.2,1.9,3.2,3.1,5.6,3.1s4.5-1.3,5.6-3.1
			c1.2,1.9,3.2,3.1,5.6,3.1c2.4,0,4.5-1.3,5.6-3.1c1.2,1.9,3.2,3.1,5.6,3.1s4.5-1.3,5.6-3.1c1.2,1.9,3.2,3.1,5.6,3.1
			c3.7,0,6.7-3,6.7-6.7C119.8,113.5,119.3,113.1,118.8,113.1z"
                    />
                </g>
            </Icon>
        );
    }
}

export class Punctures extends PureComponent {
    render() {
        return (
            <Icon>
                <g className="icon">
                    <path
                        d="M88.4,102.3c-0.2-5.4-3.9-7.4-4.8-13.9c-0.4-3.2,8.5-13.8,8.5-13.8s7.5-9.4,10.9-9.7c2.4-0.2,5,1.3,7.4,1.1c0,0,0,0,0.1,0
			c0.5-0.1,1-0.2,1.6-0.5c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.7-0.5,1.1-0.9c0.1-0.1,0.2-0.1,0.3-0.2c0,0,0,0,0-0.1c0,0,0.1,0,0.1-0.1
			c0.1-0.1,0-0.1,0.1-0.2c1.3-2,1-4.6-0.8-6.2L90.6,39.5c-1.9-1.5-4.5-1.3-6.2,0.4c-0.1,0.1-0.1,0-0.2,0.1c0,0,0,0.1,0,0.1
			c0,0,0,0-0.1,0c-0.1,0.1-0.1,0.2-0.2,0.3c-0.3,0.4-0.5,0.8-0.7,1.2c0,0.1,0,0.1,0,0.2c-0.2,0.5-0.2,1.1-0.2,1.6c0,0,0,0,0,0.1
			c0.3,2.4,2.3,4.7,2.5,7c0.3,3.5-7.4,12.6-7.4,12.6s-8.6,10.8-11.9,11c-6.6,0.4-9.3-2.9-14.6-2c-3.8,0.6-6.7,4.9-6.7,4.9l18.3,15.1
			l-13.3,16.2l-6.7,10.9l0.3,0.3l9.4-8.7l13.3-16.2l18.3,15.1C84.9,109.7,88.5,106.1,88.4,102.3z"
                    />
                </g>
            </Icon>
        );
    }
}

export class Sparks extends PureComponent {
    render() {
        return (
            <Icon>
                <g className="icon">
                    <path
                        d="M107.7,61.7c-0.2-0.5-0.8-0.9-1.4-0.9H90l7.8-26.2c0.2-0.7-0.1-1.4-0.7-1.8c-0.6-0.3-1.4-0.2-1.9,0.4L63.5,73.4
            c-0.4,0.5-0.4,1.1-0.2,1.6s0.8,0.8,1.3,0.8h16.2L71.6,102c-0.2,0.7,0,1.4,0.7,1.8c0.2,0.1,0.5,0.2,0.7,0.2
            c0.4,0,0.9-0.2,1.2-0.5l33.3-40.1C107.8,62.9,107.9,62.2,107.7,61.7z M77.3,95l7.2-20.2c0.2-0.5,0.1-1-0.2-1.4
            c-0.3-0.4-0.7-0.6-1.2-0.6H67.8l24.9-31.6l-6.1,20.6c-0.1,0.5,0,0.9,0.2,1.3c0.3,0.4,0.7,0.6,1.2,0.6h15.1L77.3,95z M66.4,92
            l1.5,3c0.2,0.5,0.7,0.8,1.2,0.8c0.2,0,0.4,0,0.6-0.1c0.7-0.3,0.9-1.1,0.6-1.8l-1.5-3c-0.3-0.7-1.1-0.9-1.8-0.6
            C66.3,90.6,66.1,91.4,66.4,92z M90.4,108l-3.2-1.1c-0.7-0.2-1.5,0.1-1.7,0.8c-0.2,0.7,0.1,1.5,0.8,1.7l3.2,1.1
            c0.1,0.1,0.3,0.1,0.4,0.1c0.6,0,1.1-0.3,1.3-0.9C91.5,109,91.1,108.3,90.4,108z M70.7,108.9c-0.6-0.4-1.5-0.1-1.8,0.5l-3.4,5.9
            c-0.4,0.6-0.1,1.5,0.5,1.8c0.2,0.1,0.4,0.2,0.7,0.2c0.5,0,0.9-0.2,1.2-0.7l3.4-5.9C71.6,110.1,71.3,109.3,70.7,108.9z
             M64.7,119.3c-0.6-0.4-1.5-0.1-1.8,0.5l-2,3.4c-0.4,0.6-0.1,1.5,0.5,1.8c0.2,0.1,0.4,0.2,0.7,0.2c0.5,0,0.9-0.2,1.2-0.7l2-3.4
            C65.6,120.5,65.4,119.7,64.7,119.3z M56.2,99.1l6.4,2.2c0.1,0.1,0.3,0.1,0.4,0.1c0.6,0,1.1-0.3,1.3-0.9c0.2-0.7-0.1-1.5-0.8-1.7
            L57,96.5c-0.7-0.2-1.5,0.1-1.7,0.8C55.1,98.1,55.5,98.8,56.2,99.1z M96.7,110.7l-2-0.7c-0.7-0.2-1.5,0.1-1.7,0.8
            c-0.2,0.7,0.1,1.5,0.8,1.7l2,0.7c0.1,0.1,0.3,0.1,0.4,0.1c0.6,0,1.1-0.3,1.3-0.9C97.8,111.7,97.4,110.9,96.7,110.7z M97.1,92.7
            l-13.6,6.6c-0.7,0.3-0.9,1.1-0.6,1.8c0.2,0.5,0.7,0.8,1.2,0.8c0.2,0,0.4,0,0.6-0.1l13.6-6.6c0.7-0.3,0.9-1.1,0.6-1.8
            C98.6,92.6,97.8,92.3,97.1,92.7z M66.3,105.2c-0.3-0.7-1.1-0.9-1.8-0.6l-13.6,6.6c-0.7,0.3-0.9,1.1-0.6,1.8
            c0.2,0.5,0.7,0.8,1.2,0.8c0.2,0,0.4,0,0.6-0.1l13.6-6.6C66.4,106.6,66.7,105.8,66.3,105.2z M78.5,109.4
            c-0.3-0.7-1.1-0.9-1.8-0.6s-0.9,1.1-0.6,1.8l3.6,7.4c0.2,0.5,0.7,0.8,1.2,0.8c0.2,0,0.4,0,0.6-0.1c0.7-0.3,0.9-1.1,0.6-1.8
            L78.5,109.4z M64.4,88c0.2,0.5,0.7,0.8,1.2,0.8c0.2,0,0.4,0,0.6-0.1c0.7-0.3,0.9-1.1,0.6-1.8l-2.9-6c-0.3-0.7-1.1-0.9-1.8-0.6
            c-0.7,0.3-0.9,1.1-0.6,1.8L64.4,88z"
                    />
                </g>
            </Icon>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/icons/index.js